import { render, staticRenderFns } from "./FooterAuth.vue?vue&type=template&id=60a477c4&scoped=true&"
import script from "./FooterAuth.vue?vue&type=script&lang=js&"
export * from "./FooterAuth.vue?vue&type=script&lang=js&"
import style0 from "./FooterAuth.vue?vue&type=style&index=0&id=60a477c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a477c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
